export default function (input: string): string {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return input.replaceAll(/[^A-Za-z0-9.\-_:]/g, '_');
}
